import { MessageSquare, Mic, Phone, Zap } from "lucide-react";

export default function ModalitiesSection() {
  const modalities = [
    {
      icon: MessageSquare,
      title: "SMS/Text",
      description: "Quick check-ins and reminders that fit into your day",
    },
    {
      icon: Mic,
      title: "Audio notes",
      description: "Voice messages for deeper reflection and guidance",
    },
    {
      icon: Phone,
      title: "Voice calls",
      description: "AI coaching conversations when you need support most",
    },
    {
      icon: Zap,
      title: "Real-time nudges",
      description: "Smart alerts from your health and calendar data",
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-secondary/50 border-y-2 border-border">
      <div className="container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center space-y-12 mb-20">
            <div className="space-y-6">
              <span className="text-primary text-sm font-bold tracking-wider uppercase">
                COMMUNICATION MODES
              </span>
              <h2 className="text-3xl md:text-5xl xl:text-6xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground max-w-4xl mx-auto">
                Fits into your day,{" "}
                <span className="text-primary">your way:</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-primary mx-auto"></div>
          </div>

          {/* Modalities grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
            {modalities.map((modality, index) => (
              <div
                key={index}
                className="bg-card border-2 border-border p-8 hover:border-primary hover:shadow-brutal hover:translate-x-1 hover:translate-y-1 transition-spring group"
              >
                <div className="space-y-6">
                  <div className="w-16 h-16 border-2 border-border bg-background flex items-center justify-center group-hover:border-primary group-hover:bg-primary transition-colors">
                    <modality.icon className="w-8 h-8 text-foreground group-hover:text-background" />
                  </div>

                  <div className="space-y-4">
                    <h3 className="text-2xl font-bold text-foreground">
                      {modality.title}
                    </h3>

                    <p className="text-muted-foreground leading-relaxed">
                      {modality.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
